import React from 'react';

const socialIcons = {
  vkontakte: (
    <svg
      className="social-icon social-icon_vkontakte"
      viewBox="0 0 14 9"
      width="100%"
      height="100%"
    >
      <path d="M6.38 8.41h.78s.23-.03.35-.16c.11-.12.11-.34.11-.34s-.01-1.05.47-1.2c.48-.15 1.09 1.01 1.74 1.46.5.33.87.26.87.26l1.74-.02s.91-.06.48-.78c-.03-.05-.25-.53-1.29-1.49-1.1-1.02-.95-.85.37-2.61.8-1.06 1.12-1.71 1.02-1.99-.1-.27-.69-.2-.69-.2l-1.96.01s-.14-.02-.25.05a.47.47 0 0 0-.17.21s-.31.82-.73 1.53C8.35 4.62 8 4.7 7.86 4.6c-.33-.21-.25-.86-.25-1.32 0-1.43.22-2.03-.43-2.19A3.6 3.6 0 0 0 6.27 1c-.7-.01-1.29 0-1.63.17-.22.11-.39.35-.29.36.13.02.43.08.58.3.2.27.19.88.19.88s.12 1.69-.26 1.9c-.27.15-.63-.15-1.41-1.49-.4-.69-.7-1.45-.7-1.45s-.06-.14-.16-.22c-.13-.09-.3-.12-.3-.12l-1.87.01s-.27.01-.38.13c-.09.11 0 .33 0 .33s1.45 3.41 3.11 5.13c1.51 1.58 3.23 1.48 3.23 1.48z" />
    </svg>
  ),
  odnoklasniki: (
    <svg
      className="social-icon social-icon_odnoklasniki"
      viewBox="0 0 297 512"
      width="100%"
      height="100%"
    >
      <path
        d="M148.4 77.442c30.175 0 54.712 24.54 54.712 54.714 0 30.143-24.537 54.687-54.712 54.687-30.142 0-54.71-24.544-54.71-54.687 0-30.173 24.568-54.714 54.71-54.714zm0 186.812c72.887 0 132.138-59.252 132.138-132.098C280.538 59.276 221.288 0 148.4 0 75.53 0 16.264 59.276 16.264 132.156c0 72.846 59.266 132.098 132.136 132.098zm53.461 107.794a247.42 247.42 0 0 0 76.731-31.783c18.083-11.396 23.534-35.297 12.138-53.38-11.381-18.122-35.27-23.574-53.384-12.178-54.124 34.041-123.813 34.026-177.907 0-18.113-11.396-42.002-5.944-53.367 12.178C-5.325 304.98.11 328.87 18.194 340.265c23.889 14.994 49.83 25.653 76.731 31.783L21.05 445.92c-15.102 15.118-15.102 39.624.016 54.742a38.623 38.623 0 0 0 27.363 11.335c9.914 0 19.827-3.784 27.395-11.335l72.561-72.592 72.624 72.592c15.102 15.119 39.609 15.119 54.727 0 15.133-15.118 15.133-39.636 0-54.742l-73.875-73.87z"
        fillRule="evenodd"
      />
    </svg>
  ),
  instagram: (
    <svg
      className="social-icon social-icon_instagram"
      viewBox="0 0 510 512"
      width="100%"
      height="100%"
    >
      <path
        d="M307.814 261.565c0-27.704-22.536-50.249-50.249-50.249-27.703 0-50.248 22.545-50.248 50.249 0 27.708 22.545 50.249 50.248 50.249 27.713 0 50.249-22.541 50.249-50.25zm70.8 0c0 66.749-54.304 121.045-121.049 121.045-66.744 0-121.045-54.296-121.045-121.045 0-18.381 4.138-35.802 11.498-51.425H0v174.424C0 454.833 57.167 512 127.436 512H382.48c70.264 0 127.432-57.167 127.432-127.436V210.14H367.117a120.339 120.339 0 0 1 11.498 51.425zM362.02 77.446c0-7.791 6.365-14.156 14.161-14.156h43.746c7.791 0 14.165 6.365 14.165 14.156v43.75c0 7.792-6.374 14.161-14.165 14.161H376.18c-7.796 0-14.16-6.369-14.16-14.16v-43.75zM257.565 140.52c26.095 0 50.262 8.324 70.053 22.42h182.294v-35.504C509.912 57.167 452.744 0 382.48 0H127.436C57.167 0 0 57.167 0 127.436v35.504h187.521c19.787-14.096 43.954-22.42 70.044-22.42z"
        fillRule="evenodd"
      />
    </svg>
  ),
  facebook: (
    <svg className="social-icon social-icon_facebook" viewBox="0 0 6 13" width="100%" height="100%">
      <path d="M5.73 6.47H3.96v6.49H1.28V6.47H0V4.18h1.28V2.71c0-1.06.5-2.71 2.7-2.71l1.99.01v2.21H4.53c-.24 0-.57.12-.57.62v1.35h2.01z" />
    </svg>
  )
};

export function getSocialIcon(type) {
  return socialIcons[type];
}
